export default __webpack_public_path__ + "static/media/liontaxi-transparent.fcf99664.png";